"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const AnalysisValidation_1 = tslib_1.__importDefault(require("./AnalysisValidation"));
const KeyValue_1 = tslib_1.__importDefault(require("./KeyValue"));
class PropositionWithAnalysis extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({ example: '8d76f49a-9cf1-4bd2-9953-3d6a0fd45306', description: 'The id of this proposition.' }),
    tslib_1.__metadata("design:type", String)
], PropositionWithAnalysis.prototype, "propositionId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'Acq AltijdDalen extra DF 3jr', description: 'Name of the proposition' }),
    tslib_1.__metadata("design:type", String)
], PropositionWithAnalysis.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'gegarandeerde daling van stroom en gas tarief, jaarlijkse daling per mei', description: 'Description of the proposition' }),
    tslib_1.__metadata("design:type", String)
], PropositionWithAnalysis.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({ example: '2022-04-20T00:00:00.000Z', description: 'The date from which this proposition is valid.' }),
    tslib_1.__metadata("design:type", Date)
], PropositionWithAnalysis.prototype, "validFrom", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({ example: '2022-04-20T00:00:00.000Z', description: 'The date to which this proposition is valid.' }),
    tslib_1.__metadata("design:type", Date)
], PropositionWithAnalysis.prototype, "validTo", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    (0, base_models_1.Docs)({ example: false, description: 'Whether this proposition is deleted or not.' }),
    tslib_1.__metadata("design:type", Boolean)
], PropositionWithAnalysis.prototype, "isDeleted", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({ example: '21334', description: 'The cdtId of this proposition.' }),
    tslib_1.__metadata("design:type", String)
], PropositionWithAnalysis.prototype, "cdtId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => AnalysisValidation_1.default),
    (0, class_validator_1.ValidateNested)(),
    tslib_1.__metadata("design:type", AnalysisValidation_1.default)
], PropositionWithAnalysis.prototype, "validation", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => KeyValue_1.default),
    tslib_1.__metadata("design:type", Array)
], PropositionWithAnalysis.prototype, "mustMatchWithNull", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => KeyValue_1.default),
    tslib_1.__metadata("design:type", Array)
], PropositionWithAnalysis.prototype, "mustMatchWithOneGroup", void 0);
exports.default = PropositionWithAnalysis;
